import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=68bfa10c&scoped=true"
import script from "./DataList.vue?vue&type=script&lang=js"
export * from "./DataList.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/data-list.css?vue&type=style&index=0&id=68bfa10c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bfa10c",
  null
  
)

export default component.exports